const filter = (value, type?: string): string => {
  if (isNaN(value)) {
    return ''
  }

  const options = {
    maximumFractionDigits: 2
  }

  switch (type) {
    case 'integer':
      options.maximumFractionDigits = 0
  }

  return value.toLocaleString('pt-BR', options)
}

export default filter
